export function GetVariable(name) {
  if(window.env && window.env[name])
    return window.env[name];
  return process.env[name];
}